import {Injectable} from '@angular/core';
import {StateService} from "@uirouter/angular";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpErrorResponse
} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/do';

import {kanAuthService} from "./auth";


@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private authService: kanAuthService, private stateService: StateService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authService.token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authService.token}`
        }
      });
    }
    return next.handle(request).do(
      (event: HttpEvent<any>) => {
      },
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status === 401) {
            this.authService.clear();
            this.stateService.go('app.login');
          }
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/modules/services/services/interceptor.ts